import React from "react";
import Tooltip from "bootstrap/js/dist/tooltip";


// create a class for the VHSFunctions that will allow me to import functions of this class into other components
export class VHSFunctions {
	static initTooltips = () => {
		const tooltipTriggerList = [].slice.call(
			document.querySelectorAll('.vhs-cart__tooltip'),
		);

		tooltipTriggerList.map(function (tooltipTriggerEl) {
			return new Tooltip(tooltipTriggerEl);
		});
	};
}

export default VHSFunctions;
